(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/game-promotion-pix/assets/javascripts/product-sizes.js') >= 0) return;  svs.modules.push('/components/banner_layouts/game-promotion-pix/assets/javascripts/product-sizes.js');
"use strict";


const allProductSizes = [
'bomben-24', 'bomben-40', 'bomben-60', 'bomben-100', 'bomben-150', 'bomben-200', 'bomben-300', 'bomben-400',
'challenge-2', 'challenge-4', 'challenge-8', 'challenge-12', 'challenge-16', 'challenge-24', 'challenge-36', 'challenge-48', 'challenge-64', 'challenge-72',
'europatipset-2', 'europatipset-4', 'europatipset-8', 'europatipset-16', 'europatipset-24', 'europatipset-32', 'europatipset-48', 'europatipset-64', 'europatipset-72', 'europatipset-96', 'europatipset-128', 'europatipset-144', 'europatipset-192', 'europatipset-256', 'europatipset-512',
'powerplay-2', 'powerplay-4', 'powerplay-8', 'powerplay-16', 'powerplay-24', 'powerplay-32', 'powerplay-48', 'powerplay-64', 'powerplay-72', 'powerplay-96', 'powerplay-108', 'powerplay-128', 'powerplay-144', 'powerplay-192', 'powerplay-243',
'stryktipset-2', 'stryktipset-4', 'stryktipset-8', 'stryktipset-16', 'stryktipset-24', 'stryktipset-32', 'stryktipset-48', 'stryktipset-64', 'stryktipset-72', 'stryktipset-96', 'stryktipset-128', 'stryktipset-144', 'stryktipset-192', 'stryktipset-256', 'stryktipset-512',
'topptipset-2', 'topptipset-4', 'topptipset-8', 'topptipset-16', 'topptipset-24', 'topptipset-32', 'topptipset-48', 'topptipset-64', 'topptipset-72', 'topptipset-96', 'topptipset-108', 'topptipset-128', 'topptipset-144', 'topptipset-192', 'topptipset-243'];

function getProductSizes(product) {
  return allProductSizes.filter(size => size.split('-')[0] === product).map(size => size.split('-')[1]);
}

const toExport = {
  getProductSizes
};

if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.banner_layouts.game_promotion_pix', toExport);
}

 })(window);